import { render, staticRenderFns } from "./PdfTemplateBoxesTable.vue?vue&type=template&id=9e629354&scoped=true&"
import script from "./PdfTemplateBoxesTable.vue?vue&type=script&lang=js&"
export * from "./PdfTemplateBoxesTable.vue?vue&type=script&lang=js&"
import style0 from "./PdfTemplateBoxesTable.vue?vue&type=style&index=0&id=9e629354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e629354",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
